export function emailRejectedHTML(toName, yardName) {
  return `<!-- Begin HTML Content -->
        <h1> ${toName}, <br><br></h1>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        Thank you for your interest in transloads.co
        <br><br>
        Upon review of your ${yardName} setup, the registration request has been rejected.
        <br><br>
        Mostly, that happens if this transload is already registered in our system.
        <br><br>
        if you think your request has been rejected by mistake, please contact us at:
        <br><br>
        <strong>
            <a href="email:support@transloads.co"
                target="_blank"
                rel="noreferrer"
                style="color: #2d8cff; text-decoration:none; word-break: break-all;"
            >
                support@transloads.co
            </a>
            <br><br>
            OR
            <br><br>
            1-877-TRANSLOAD
        </strong>
        <br><br>
        We apologize for any inconvenience!
        <br><br>
        Customer Success Team
        <br>
        transloads.co
        <!-- End HTML Content -->`;
}
